var map = {
	"./arrows/angle-right": 8,
	"./arrows/angle-right.svg": 8,
	"./arrows/bullet": 9,
	"./arrows/bullet-down": 10,
	"./arrows/bullet-down.svg": 10,
	"./arrows/bullet.svg": 9,
	"./arrows/down": 11,
	"./arrows/down.svg": 11,
	"./arrows/left": 12,
	"./arrows/left.svg": 12,
	"./arrows/right": 13,
	"./arrows/right.svg": 13,
	"./arrows/tail-spin": 14,
	"./arrows/tail-spin.svg": 14,
	"./bg/about-us": 15,
	"./bg/about-us.svg": 15,
	"./bg/curve-line": 16,
	"./bg/curve-line.svg": 16,
	"./bg/logo-watermark": 17,
	"./bg/logo-watermark.svg": 17,
	"./bg/loop": 18,
	"./bg/loop.svg": 18,
	"./bg/panorama": 19,
	"./bg/panorama.svg": 19,
	"./bg/quote": 20,
	"./bg/quote.svg": 20,
	"./bg/ribbon": 21,
	"./bg/ribbon.svg": 21,
	"./bg/separator": 22,
	"./bg/separator.svg": 22,
	"./bg/shapes/awards": 23,
	"./bg/shapes/awards.svg": 23,
	"./bg/shapes/courses-at-school": 24,
	"./bg/shapes/courses-at-school.svg": 24,
	"./bg/shapes/individual-courses": 25,
	"./bg/shapes/individual-courses.svg": 25,
	"./bg/shapes/media": 26,
	"./bg/shapes/media.svg": 26,
	"./bg/shapes/online-courses": 27,
	"./bg/shapes/online-courses.svg": 27,
	"./bg/shapes/privacy-policy": 28,
	"./bg/shapes/privacy-policy.svg": 28,
	"./bg/shapes/semester-course": 29,
	"./bg/shapes/semester-course.svg": 29,
	"./bg/shapes/tests": 30,
	"./bg/shapes/tests.svg": 30,
	"./bg/shapes/workshops": 31,
	"./bg/shapes/workshops.svg": 31,
	"./bg/video-button": 32,
	"./bg/video-button.svg": 32,
	"./bg/yellow-line": 33,
	"./bg/yellow-line.svg": 33,
	"./icons/avatar": 34,
	"./icons/avatar.svg": 34,
	"./icons/awards": 35,
	"./icons/awards.svg": 35,
	"./icons/badge": 36,
	"./icons/badge.svg": 36,
	"./icons/birthday": 37,
	"./icons/birthday.svg": 37,
	"./icons/bulb": 38,
	"./icons/bulb.svg": 38,
	"./icons/cake": 39,
	"./icons/cake.svg": 39,
	"./icons/calendar": 40,
	"./icons/calendar.svg": 40,
	"./icons/chat": 41,
	"./icons/chat-dots": 42,
	"./icons/chat-dots.svg": 42,
	"./icons/chat.svg": 41,
	"./icons/check-green": 43,
	"./icons/check-green.svg": 43,
	"./icons/circles": 44,
	"./icons/circles.svg": 44,
	"./icons/clock": 45,
	"./icons/clock.svg": 45,
	"./icons/close": 46,
	"./icons/close-white": 47,
	"./icons/close-white.svg": 47,
	"./icons/close.svg": 46,
	"./icons/clover": 48,
	"./icons/clover.svg": 48,
	"./icons/coffee": 49,
	"./icons/coffee.svg": 49,
	"./icons/cookies": 50,
	"./icons/cookies.svg": 50,
	"./icons/copy": 51,
	"./icons/copy.svg": 51,
	"./icons/courses/1": 52,
	"./icons/courses/1.svg": 52,
	"./icons/courses/10": 53,
	"./icons/courses/10.svg": 53,
	"./icons/courses/2": 54,
	"./icons/courses/2.svg": 54,
	"./icons/courses/3": 55,
	"./icons/courses/3.svg": 55,
	"./icons/courses/4": 56,
	"./icons/courses/4.svg": 56,
	"./icons/courses/5": 57,
	"./icons/courses/5.svg": 57,
	"./icons/courses/6": 58,
	"./icons/courses/6.svg": 58,
	"./icons/courses/7": 59,
	"./icons/courses/7.svg": 59,
	"./icons/courses/8": 60,
	"./icons/courses/8.svg": 60,
	"./icons/courses/9": 61,
	"./icons/courses/9.svg": 61,
	"./icons/cross": 62,
	"./icons/cross.svg": 62,
	"./icons/dots": 63,
	"./icons/dots.svg": 63,
	"./icons/ea": 64,
	"./icons/ea.svg": 64,
	"./icons/envelop": 65,
	"./icons/envelop.svg": 65,
	"./icons/eu-flag": 66,
	"./icons/eu-flag.svg": 66,
	"./icons/facebook-black": 67,
	"./icons/facebook-black.svg": 67,
	"./icons/facebook-white": 68,
	"./icons/facebook-white.svg": 68,
	"./icons/fb": 69,
	"./icons/fb.svg": 69,
	"./icons/group": 70,
	"./icons/group.svg": 70,
	"./icons/hands": 71,
	"./icons/hands.svg": 71,
	"./icons/heart": 72,
	"./icons/heart-pink": 73,
	"./icons/heart-pink.svg": 73,
	"./icons/heart.svg": 72,
	"./icons/horn": 74,
	"./icons/horn-green": 75,
	"./icons/horn-green.svg": 75,
	"./icons/horn.svg": 74,
	"./icons/instagram-black": 76,
	"./icons/instagram-black.svg": 76,
	"./icons/instagram-white": 77,
	"./icons/instagram-white.svg": 77,
	"./icons/lets-talk": 78,
	"./icons/lets-talk.svg": 78,
	"./icons/lightbulb": 79,
	"./icons/lightbulb.svg": 79,
	"./icons/linked-in": 80,
	"./icons/linked-in.svg": 80,
	"./icons/linkedin": 81,
	"./icons/linkedin.svg": 81,
	"./icons/logo": 82,
	"./icons/logo.svg": 82,
	"./icons/magnifier": 83,
	"./icons/magnifier.svg": 83,
	"./icons/marker": 84,
	"./icons/marker-xx": 85,
	"./icons/marker-xx.svg": 85,
	"./icons/marker.svg": 84,
	"./icons/media": 86,
	"./icons/media.svg": 86,
	"./icons/message": 87,
	"./icons/message.svg": 87,
	"./icons/mobile": 88,
	"./icons/mobile-xx": 89,
	"./icons/mobile-xx.svg": 89,
	"./icons/mobile.svg": 88,
	"./icons/monitor": 90,
	"./icons/monitor.svg": 90,
	"./icons/msg": 91,
	"./icons/msg.svg": 91,
	"./icons/note": 92,
	"./icons/note.svg": 92,
	"./icons/paycard": 93,
	"./icons/paycard.svg": 93,
	"./icons/phone": 94,
	"./icons/phone.svg": 94,
	"./icons/pin": 95,
	"./icons/pin.svg": 95,
	"./icons/pink-smile": 96,
	"./icons/pink-smile.svg": 96,
	"./icons/play": 97,
	"./icons/play.svg": 97,
	"./icons/price": 98,
	"./icons/price.svg": 98,
	"./icons/quote": 99,
	"./icons/quote-2": 100,
	"./icons/quote-2.svg": 100,
	"./icons/quote.svg": 99,
	"./icons/sheet": 101,
	"./icons/sheet.svg": 101,
	"./icons/sliders": 102,
	"./icons/sliders.svg": 102,
	"./icons/smile": 103,
	"./icons/smile.svg": 103,
	"./icons/sound": 104,
	"./icons/sound.svg": 104,
	"./icons/speech-bubble": 105,
	"./icons/speech-bubble.svg": 105,
	"./icons/stairs": 106,
	"./icons/stairs.svg": 106,
	"./icons/star": 107,
	"./icons/star-black": 108,
	"./icons/star-black.svg": 108,
	"./icons/star.svg": 107,
	"./icons/sun": 109,
	"./icons/sun-black": 110,
	"./icons/sun-black.svg": 110,
	"./icons/sun.svg": 109,
	"./icons/talk": 111,
	"./icons/talk.svg": 111,
	"./icons/testimonials": 112,
	"./icons/testimonials.svg": 112,
	"./icons/time": 113,
	"./icons/time.svg": 113,
	"./icons/to-listen": 114,
	"./icons/to-listen.svg": 114,
	"./icons/to-read": 115,
	"./icons/to-read.svg": 115,
	"./icons/to-watch": 116,
	"./icons/to-watch.svg": 116,
	"./icons/twitter": 117,
	"./icons/twitter.svg": 117,
	"./icons/yellow-star": 118,
	"./icons/yellow-star.svg": 118,
	"./laughing-people": 119,
	"./laughing-people.jpg": 119,
	"./logo": 120,
	"./logo-white": 121,
	"./logo-white.svg": 121,
	"./logo.svg": 120,
	"./pic/anime/airplane": 122,
	"./pic/anime/airplane.svg": 122,
	"./pic/anime/awards": 123,
	"./pic/anime/awards.svg": 123,
	"./pic/anime/badminton-back": 124,
	"./pic/anime/badminton-back.svg": 124,
	"./pic/anime/badminton-front": 125,
	"./pic/anime/badminton-front.svg": 125,
	"./pic/anime/bird": 126,
	"./pic/anime/bird.svg": 126,
	"./pic/anime/bookworm": 127,
	"./pic/anime/bookworm.svg": 127,
	"./pic/anime/box-blog-type1": 128,
	"./pic/anime/box-blog-type1.svg": 128,
	"./pic/anime/box-blog-type2": 129,
	"./pic/anime/box-blog-type2.svg": 129,
	"./pic/anime/box-blog-type3": 130,
	"./pic/anime/box-blog-type3.svg": 130,
	"./pic/anime/box-blog-type4": 131,
	"./pic/anime/box-blog-type4-top": 132,
	"./pic/anime/box-blog-type4-top.svg": 132,
	"./pic/anime/box-blog-type4.svg": 131,
	"./pic/anime/bread": 133,
	"./pic/anime/bread.svg": 133,
	"./pic/anime/cake": 134,
	"./pic/anime/cake.svg": 134,
	"./pic/anime/cup-of-coffee": 135,
	"./pic/anime/cup-of-coffee.svg": 135,
	"./pic/anime/dumplings": 136,
	"./pic/anime/dumplings.svg": 136,
	"./pic/anime/envelope": 137,
	"./pic/anime/envelope.svg": 137,
	"./pic/anime/glasses": 138,
	"./pic/anime/glasses.svg": 138,
	"./pic/anime/green-heart": 139,
	"./pic/anime/green-heart.svg": 139,
	"./pic/anime/heart": 140,
	"./pic/anime/heart.svg": 140,
	"./pic/anime/heroes": 141,
	"./pic/anime/heroes.svg": 141,
	"./pic/anime/laptop": 142,
	"./pic/anime/laptop.svg": 142,
	"./pic/anime/librarian": 143,
	"./pic/anime/librarian.svg": 143,
	"./pic/anime/lock": 144,
	"./pic/anime/lock.svg": 144,
	"./pic/anime/marker": 145,
	"./pic/anime/marker.svg": 145,
	"./pic/anime/megaphone": 146,
	"./pic/anime/megaphone-2": 147,
	"./pic/anime/megaphone-2.svg": 147,
	"./pic/anime/megaphone.svg": 146,
	"./pic/anime/monument": 148,
	"./pic/anime/monument.png": 148,
	"./pic/anime/mountain": 149,
	"./pic/anime/mountain.svg": 149,
	"./pic/anime/mr-popcorn": 150,
	"./pic/anime/mr-popcorn.svg": 150,
	"./pic/anime/music": 151,
	"./pic/anime/music.svg": 151,
	"./pic/anime/party": 152,
	"./pic/anime/party.svg": 152,
	"./pic/anime/pink-crayon": 153,
	"./pic/anime/pink-crayon.svg": 153,
	"./pic/anime/popcorn": 154,
	"./pic/anime/popcorn.svg": 154,
	"./pic/anime/romper": 155,
	"./pic/anime/romper-shadow": 156,
	"./pic/anime/romper-shadow.svg": 156,
	"./pic/anime/romper.svg": 155,
	"./pic/anime/school": 157,
	"./pic/anime/school.svg": 157,
	"./pic/anime/scooter": 158,
	"./pic/anime/scooter.svg": 158,
	"./pic/anime/singers": 159,
	"./pic/anime/singers.svg": 159,
	"./pic/anime/slide": 160,
	"./pic/anime/slide.svg": 160,
	"./pic/anime/superhero": 161,
	"./pic/anime/superhero.svg": 161,
	"./pic/anime/sweet-kitties": 162,
	"./pic/anime/sweet-kitties.svg": 162,
	"./pic/anime/team": 163,
	"./pic/anime/team.svg": 163,
	"./pic/anime/varia": 164,
	"./pic/anime/varia.svg": 164,
	"./pic/banners/book-course": 0,
	"./pic/banners/book-course.jpeg": 264,
	"./pic/banners/book-course.svg": 0,
	"./pic/banners/online-learning": 1,
	"./pic/banners/online-learning.jpeg": 265,
	"./pic/banners/online-learning.svg": 1,
	"./pic/banners/sing-up": 2,
	"./pic/banners/sing-up.jpeg": 266,
	"./pic/banners/sing-up.svg": 2,
	"./pic/banners/stationary-courses": 3,
	"./pic/banners/stationary-courses.jpeg": 267,
	"./pic/banners/stationary-courses.svg": 3,
	"./pic/best-place": 165,
	"./pic/best-place.png": 165,
	"./pic/blog": 166,
	"./pic/blog.jpeg": 166,
	"./pic/blog/justyna-kotlarczyk": 167,
	"./pic/blog/justyna-kotlarczyk.jpeg": 167,
	"./pic/blog_author_default": 168,
	"./pic/blog_author_default.svg": 168,
	"./pic/contact/agnieszka-zieba": 169,
	"./pic/contact/agnieszka-zieba.jpeg": 169,
	"./pic/contact/aneta-kawa": 170,
	"./pic/contact/aneta-kawa.jpeg": 170,
	"./pic/contact/justyna-kotlarczyk": 171,
	"./pic/contact/justyna-kotlarczyk.jpeg": 171,
	"./pic/contact/justyna-szybinska": 172,
	"./pic/contact/justyna-szybinska.jpeg": 172,
	"./pic/contact/katarzyna-hoffmann": 173,
	"./pic/contact/katarzyna-hoffmann.jpeg": 173,
	"./pic/contact/magdalena-devault": 174,
	"./pic/contact/magdalena-devault.jpeg": 174,
	"./pic/contact/valentyna-kulinich": 175,
	"./pic/contact/valentyna-kulinich.jpeg": 175,
	"./pic/cosmos": 176,
	"./pic/cosmos.jpeg": 176,
	"./pic/courses/1": 177,
	"./pic/courses/1.jpeg": 177,
	"./pic/courses/2": 178,
	"./pic/courses/2.jpeg": 178,
	"./pic/courses/3": 179,
	"./pic/courses/3.jpeg": 179,
	"./pic/courses/4": 180,
	"./pic/courses/4.jpeg": 180,
	"./pic/courses/5": 181,
	"./pic/courses/5.jpeg": 181,
	"./pic/courses/6": 182,
	"./pic/courses/6.jpeg": 182,
	"./pic/courses/7": 183,
	"./pic/courses/7.jpeg": 183,
	"./pic/courses/8": 184,
	"./pic/courses/8.jpeg": 184,
	"./pic/dance": 185,
	"./pic/dance.jpeg": 185,
	"./pic/example": 186,
	"./pic/example.jpeg": 186,
	"./pic/family-1": 187,
	"./pic/family-1.jpeg": 187,
	"./pic/family-2": 188,
	"./pic/family-2.jpeg": 188,
	"./pic/family-3": 189,
	"./pic/family-3.jpeg": 189,
	"./pic/groups/early-school": 190,
	"./pic/groups/early-school.jpg": 190,
	"./pic/groups/kindergarten": 191,
	"./pic/groups/kindergarten.jpg": 191,
	"./pic/groups/school": 192,
	"./pic/groups/school.jpg": 192,
	"./pic/groups/small/early-school": 193,
	"./pic/groups/small/early-school.jpeg": 193,
	"./pic/groups/small/kindergarten": 194,
	"./pic/groups/small/kindergarten.jpeg": 194,
	"./pic/groups/small/school": 195,
	"./pic/groups/small/school.jpeg": 195,
	"./pic/groups/small/youth": 196,
	"./pic/groups/small/youth.jpeg": 196,
	"./pic/groups/youth": 197,
	"./pic/groups/youth.jpg": 197,
	"./pic/hero/courses/online/early-school": 198,
	"./pic/hero/courses/online/early-school.jpeg": 198,
	"./pic/hero/courses/online/preschool": 199,
	"./pic/hero/courses/online/preschool.jpeg": 199,
	"./pic/hero/courses/online/school": 200,
	"./pic/hero/courses/online/school.jpeg": 200,
	"./pic/hero/courses/online/youth": 201,
	"./pic/hero/courses/online/youth.jpeg": 201,
	"./pic/hero/courses/school/early-school": 202,
	"./pic/hero/courses/school/early-school.jpeg": 202,
	"./pic/hero/courses/school/preschool": 203,
	"./pic/hero/courses/school/preschool.jpeg": 203,
	"./pic/hero/courses/school/school": 204,
	"./pic/hero/courses/school/school.jpeg": 204,
	"./pic/hero/courses/school/youth": 205,
	"./pic/hero/courses/school/youth.jpeg": 205,
	"./pic/hero/dance": 206,
	"./pic/hero/dance.jpeg": 206,
	"./pic/hero/hero": 207,
	"./pic/hero/hero.svg": 207,
	"./pic/image": 208,
	"./pic/image.jpeg": 208,
	"./pic/justyna-szybinska": 209,
	"./pic/justyna-szybinska.jpeg": 209,
	"./pic/kid": 210,
	"./pic/kid-mobile": 211,
	"./pic/kid-mobile.jpeg": 211,
	"./pic/kid.jpeg": 210,
	"./pic/laughing-people": 212,
	"./pic/laughing-people.jpeg": 212,
	"./pic/lectors/agata-miks-lorenzoni": 213,
	"./pic/lectors/agata-miks-lorenzoni.jpeg": 213,
	"./pic/lectors/agnieszka-zieba": 214,
	"./pic/lectors/agnieszka-zieba.jpeg": 214,
	"./pic/lectors/aneta-i-katarzyna": 215,
	"./pic/lectors/aneta-i-katarzyna.jpeg": 215,
	"./pic/lectors/anita-lawrynowicz": 216,
	"./pic/lectors/anita-lawrynowicz.jpeg": 216,
	"./pic/lectors/dorota-rybinska": 217,
	"./pic/lectors/dorota-rybinska.jpeg": 217,
	"./pic/lectors/gabriela-kwasniewska": 218,
	"./pic/lectors/gabriela-kwasniewska.jpeg": 218,
	"./pic/lectors/iga-figiel": 219,
	"./pic/lectors/iga-figiel.jpeg": 219,
	"./pic/lectors/iga-strzalka": 220,
	"./pic/lectors/iga-strzalka.jpeg": 220,
	"./pic/lectors/justyna-szybinska": 221,
	"./pic/lectors/justyna-szybinska-big": 222,
	"./pic/lectors/justyna-szybinska-big.jpeg": 222,
	"./pic/lectors/justyna-szybinska.jpeg": 221,
	"./pic/lectors/klaudia-mucha-iwaniczko": 223,
	"./pic/lectors/klaudia-mucha-iwaniczko.jpeg": 223,
	"./pic/lectors/magdalena-devault": 224,
	"./pic/lectors/magdalena-devault.jpeg": 224,
	"./pic/lectors/marianna-szumal": 225,
	"./pic/lectors/marianna-szumal.jpeg": 225,
	"./pic/lectors/natalia-wojcik": 226,
	"./pic/lectors/natalia-wojcik.jpeg": 226,
	"./pic/lectors/nicola-agier": 227,
	"./pic/lectors/nicola-agier.jpeg": 227,
	"./pic/lectors/patrycja-palka": 228,
	"./pic/lectors/patrycja-palka.jpeg": 228,
	"./pic/lesson": 229,
	"./pic/lesson.jpeg": 229,
	"./pic/news-main": 4,
	"./pic/news-main-blank": 230,
	"./pic/news-main-blank.svg": 230,
	"./pic/news-main.jpg": 268,
	"./pic/news-main.svg": 4,
	"./pic/pink-bird": 231,
	"./pic/pink-bird.svg": 231,
	"./pic/reviews_default": 232,
	"./pic/reviews_default.svg": 232,
	"./pic/reviews_video_default": 233,
	"./pic/reviews_video_default.svg": 233,
	"./pic/rewards_default": 234,
	"./pic/rewards_default.svg": 234,
	"./pic/rodzice-evy-i-milana": 235,
	"./pic/rodzice-evy-i-milana.jpeg": 235,
	"./pic/rodzice-witusia": 236,
	"./pic/rodzice-witusia.jpeg": 236,
	"./pic/sample1": 5,
	"./pic/sample1.jpg": 5,
	"./pic/sample1.webp": 269,
	"./pic/sample2": 6,
	"./pic/sample2.jpg": 6,
	"./pic/sample2.webp": 270,
	"./pic/sample3": 7,
	"./pic/sample3.jpg": 7,
	"./pic/sample3.webp": 271,
	"./pic/smiling-kids": 237,
	"./pic/smiling-kids.jpeg": 237,
	"./pic/sontag-aktuell": 238,
	"./pic/sontag-aktuell.png": 238,
	"./pic/talent-friendly-company": 239,
	"./pic/talent-friendly-company.png": 239,
	"./pic/teachers": 240,
	"./pic/teachers.jpeg": 240,
	"./pic/team": 241,
	"./pic/team-people": 242,
	"./pic/team-people.jpeg": 242,
	"./pic/team.jpeg": 241,
	"./pic/team_contact_default": 243,
	"./pic/team_contact_default.svg": 243,
	"./pic/team_management_default": 244,
	"./pic/team_management_default.svg": 244,
	"./pic/team_teachers_default": 245,
	"./pic/team_teachers_default.svg": 245,
	"./pic/varia": 246,
	"./pic/varia.jpeg": 246,
	"./pic/video/1": 247,
	"./pic/video/1.jpeg": 247,
	"./pic/video/2": 248,
	"./pic/video/2.jpeg": 248,
	"./pic/video/3": 249,
	"./pic/video/3.jpeg": 249,
	"./pic/workshops/czesc-czesio": 250,
	"./pic/workshops/czesc-czesio.jpeg": 250,
	"./pic/workshops/familiada": 251,
	"./pic/workshops/familiada.jpeg": 251,
	"./pic/workshops/kazdy-tego-slucha": 252,
	"./pic/workshops/kazdy-tego-slucha.jpeg": 252,
	"./pic/workshops/pomaluj-moj-swiat": 253,
	"./pic/workshops/pomaluj-moj-swiat.jpeg": 253,
	"./pic/workshops/quiz-o-polsce": 254,
	"./pic/workshops/quiz-o-polsce.jpeg": 254,
	"./pic/workshops/sorki-nie-czaje": 255,
	"./pic/workshops/sorki-nie-czaje.jpeg": 255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;